module.exports = __webpack_public_path__ + "media/images/flags/4x3/khm-2fbda01fa3e6fbfa3fc741df14e65244.svg";